import { Star, ExternalLink, PenLine } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal, Overline, OrnamentDivider } from "./Reveal";
import { useLang } from "../i18n";

export const Reviews = () => {
    const { t } = useLang();
    return (
    <section id="reviews" data-testid="reviews-section" className="relative py-24 sm:py-32 overflow-hidden">
        <div
            className="absolute inset-0"
            style={{ background: "radial-gradient(ellipse 55% 45% at 50% 50%, rgba(217,119,6,0.09), transparent 70%)" }}
            aria-hidden="true"
        />
        <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
            <Reveal>
                <Overline>{t("reviews.overline")}</Overline>
                <div className="mt-8 flex items-center justify-center gap-1.5" aria-hidden="true">
                    {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-6 h-6 text-saffron-glow fill-saffron-glow" strokeWidth={1} />
                    ))}
                </div>
                <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.08] text-balance">
                    {t("reviews.h1a")} <span className="italic gold-text">{t("reviews.h1b")}</span>
                </h2>
                <OrnamentDivider className="mt-8 justify-center" />
                <p className="mt-8 text-stone-300 font-light leading-relaxed max-w-xl mx-auto">
                    {t("reviews.body")}
                </p>
                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <a
                        data-testid="reviews-google-button"
                        href={SITE.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2.5 rounded-full bg-saffron px-8 py-4 text-sm font-semibold tracking-wide text-ink hover:bg-saffron-bright hover:shadow-[0_0_36px_rgba(217,119,6,0.35)] transition-[background-color,box-shadow] duration-300"
                    >
                        <ExternalLink className="w-4 h-4" />
                        {t("reviews.cta1")}
                    </a>
                    <a
                        data-testid="reviews-write-button"
                        href={SITE.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2.5 rounded-full gold-border px-8 py-4 text-sm font-semibold tracking-wide text-cream hover:border-saffron/60 hover:text-saffron-glow transition-[border-color,color] duration-300"
                    >
                        <PenLine className="w-4 h-4" />
                        {t("reviews.cta2")}
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
};

